const LogosBanner = () => (
  <div className="grid__container">
    <div className="grid__row content-block logo-banner">
      <img
        src="https://content.skyscnr.com/asset/54fff88f-d934-493c-8cb4-6ee87a2bcc13/Jobssite-Disability-Logo-Update-1.png"
        alt="Disability Confident Employer Logo"
      />
      <img
        src="https://content.skyscnr.com/m/13e857afe7b2a8bd/original/stonewall_jobs_logo.png"
        alt="Stonewall Top Global Employer 2025 - Silver Logo"
      />
      <img
        src="https://content.skyscnr.com/asset/1403287e-c6c0-4a17-9567-256c9e724583/Jobssite-UK-undergraduate-Top-Employer-1.png"
        alt="GTI Cibyl UK Graduate Survey Top 300 Employer 2026 Logo"
      />
    </div>
  </div>
);

export default LogosBanner;
